import { Component } from '@angular/core';

@Component({
  selector: 'app-un-authenticated',
  templateUrl: './un-authenticated.component.html',
  styleUrl: './un-authenticated.component.scss',
  standalone: false,
})
export class UnAuthenticatedComponent {}
